'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage from "./presto.-Register-Directive-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterDirectivePage$() {
}
export { $c_Lpresto_RegisterDirectivePage$ as $c_Lpresto_RegisterDirectivePage$ };
$p = $c_Lpresto_RegisterDirectivePage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterDirectivePage$;
/** @constructor */
function $h_Lpresto_RegisterDirectivePage$() {
}
export { $h_Lpresto_RegisterDirectivePage$ as $h_Lpresto_RegisterDirectivePage$ };
$h_Lpresto_RegisterDirectivePage$.prototype = $p;
$p.l = (function() {
  return "RegisterDirectivePage";
});
$p.cFB = (function(x$0) {
  return new $j_presto$002e$002dRegister$002dDirective$002dPage.$c_Lpresto_RegisterDirectivePage(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_RegisterDirectivePage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterDirectivePage$, "presto.RegisterDirectivePage$", ({
  Q4: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_RegisterDirectivePage$ as $d_Lpresto_RegisterDirectivePage$ };
var $n_Lpresto_RegisterDirectivePage$;
function $m_Lpresto_RegisterDirectivePage$() {
  if ((!$n_Lpresto_RegisterDirectivePage$)) {
    $n_Lpresto_RegisterDirectivePage$ = new $c_Lpresto_RegisterDirectivePage$();
  }
  return $n_Lpresto_RegisterDirectivePage$;
}
export { $m_Lpresto_RegisterDirectivePage$ as $m_Lpresto_RegisterDirectivePage$ };
//# sourceMappingURL=presto.-Register-Directive-Page$.js.map
